import React, { useState, useEffect } from 'react';
import T from 'prop-types';
// utils
import { isEmpty } from 'lodash';
// components
import ScorePercentageIndicator from 'components/Indicator/ScorePercentageIndicator';
import Indicator from 'components/Indicator';
import Typography from 'components/Typography';
import Modal from 'components/Modal';
// styles
import classnames from 'classnames/bind';
import styles from './AssessmentModal.module.scss';

const cx = classnames.bind(styles);

const AssessmentModal = ({ assessmentData = {}, onClose }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    if (!isEmpty(assessmentData)) {
      setData(assessmentData);
    }
  }, [assessmentData]);

  return (
    <Modal className={cx('body-wrapper')} isOpen={!isEmpty(assessmentData)} onClose={onClose}>
      <div className={cx('heading-wrapper', 'row-item')}>
        <Typography type="body-xs">Question {data.number}</Typography>
        <Typography type="body-xs">Class Performance</Typography>
      </div>
      <div className={cx('row-item', 'mgt-20')}>
        <Typography className={cx('heading-paragraph')}>{data.content}</Typography>
        {!!data.scoreRatio && <ScorePercentageIndicator score={data.scoreRatio} />}
      </div>
      <ul>
        {(data.answers || []).map(({ id, correct, content, student_answers_count: numCorrect }) => (
          <li key={id} className={cx('answer-item', 'mgt-20')}>
            <Indicator checked={correct} />
            <Typography className="mgl-10" type="body-s">
              {content}
            </Typography>
            <Typography className="mgl-auto">
              {numCorrect} / {data.students_answers_count}
            </Typography>
          </li>
        ))}
      </ul>
      {!!data.tip && (
        <>
          <div className={cx('hr', 'mgt-30')} />
          <Typography className={cx('heading-paragraph', 'mgt-20')}>Teaching Tip</Typography>
          <Typography className={cx('teaching-tip', 'mgt-10')}>{data.tip}</Typography>
        </>
      )}
    </Modal>
  );
};

AssessmentModal.propTypes = {
  assessmentData: T.object.isRequired,
  onClose: T.func.isRequired,
};

export default AssessmentModal;
